import { useTranslation } from 'react-i18next'
import { LocalizedValue } from 'types/entities'

const useLanguage = () => {
  const { i18n } = useTranslation()
  return i18n.language as keyof LocalizedValue
}

export default useLanguage
